// Product pairs offered in the "Cặp sản phẩm" picker. OTHER_PAIR groups every symbol that is not in the list
// (e.g. IMXUSD, US30, XAUUSD.m), otherwise trades on those symbols could never be shown.
export const PRODUCT_PAIRS = ['XAUUSD', 'BTC', 'BTCUSD', 'ETH', 'ETHUSD', 'USDAUD', 'EURUSD', 'GBPUSD', 'AUDUSD', 'USDCAD', 'USDCHF', 'NZDUSD'];
export const OTHER_PAIR = 'Khác';
export const PAIR_OPTIONS = [...PRODUCT_PAIRS, OTHER_PAIR];

const KNOWN = new Set(PRODUCT_PAIRS.map((p) => p.toUpperCase()));

/** Does a trade on `tradeSymbol` belong to the selected pair? An empty selection matches everything. */
export function matchesPair(tradeSymbol: unknown, selectedPair?: string): boolean {
    const sel = String(selectedPair || '').trim().toUpperCase();
    if (!sel) return true;
    const sym = String(tradeSymbol || '').trim().toUpperCase();
    if (sel === OTHER_PAIR.toUpperCase()) return !!sym && !KNOWN.has(sym);
    return sym === sel;
}

/** Text used in messages: "XAUUSD" or "các cặp khác" */
export function pairLabel(selectedPair?: string): string {
    return String(selectedPair || '').trim().toUpperCase() === OTHER_PAIR.toUpperCase() ? 'các cặp khác' : String(selectedPair || '');
}
